import { render, staticRenderFns } from "./MainLedgerAnalysis.vue?vue&type=template&id=054f351d"
import script from "./MainLedgerAnalysis.vue?vue&type=script&lang=js"
export * from "./MainLedgerAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports